import React, { useEffect, useState } from "react";
import styles from "./ComingSoon.module.css";

/* =========================================================
   LAUNCH DATE
   15 AUGUST 2026 - 12:00 PM IST
========================================================= */

const LAUNCH_DATE = new Date(
  "2026-08-15T13:30:00+05:30"
).getTime();


/* =========================================================
   COUNTDOWN
========================================================= */

function getTimeLeft() {

  const difference = LAUNCH_DATE - Date.now();

  if (difference <= 0) {

    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      completed: true,
    };

  }

  return {

    days: Math.floor(
      difference / (1000 * 60 * 60 * 24)
    ),

    hours: Math.floor(
      (difference / (1000 * 60 * 60)) % 24
    ),

    minutes: Math.floor(
      (difference / (1000 * 60)) % 60
    ),

    seconds: Math.floor(
      (difference / 1000) % 60
    ),

    completed: false,

  };

}


/* =========================================================
   TIME BOX
========================================================= */

function TimeBox({ value, label }) {

  return (

    <div className={styles.timeBox}>

      <div className={styles.timeValue}>
        {String(value).padStart(2, "0")}
      </div>

      <div className={styles.timeLabel}>
        {label}
      </div>

    </div>

  );

}


/* =========================================================
   MAIN COMPONENT
========================================================= */

const ComingSoon = ({ onEnterWebsite }) => {

  const [timeLeft, setTimeLeft] =
    useState(getTimeLeft());

  const [celebrating, setCelebrating] =
    useState(false);


  /* =======================================================
     COUNTDOWN
  ======================================================= */

  useEffect(() => {

    const timer = setInterval(() => {

      setTimeLeft(getTimeLeft());

    }, 1000);

    return () => clearInterval(timer);

  }, []);


  /* =======================================================
     ENTER WEBSITE
     30 SECOND CELEBRATION
  ======================================================= */

  const handleEnterWebsite = () => {

    if (celebrating) return;

    setCelebrating(true);

    setTimeout(() => {

      onEnterWebsite();

    }, 5000);

  };


  return (

    <div className={styles.page}>


      {/* =================================================
          BACKGROUND
      ================================================= */}

      <div className={styles.bg}></div>

      <div className={styles.bgGlow}></div>


      {/* =================================================
          ASHOKA CHAKRA
      ================================================= */}

      <div className={styles.chakra}>

        <div className={styles.chakraCenter}></div>

        {Array.from({ length: 24 }).map(
          (_, index) => (

            <span
              key={index}
              style={{
                transform:
                  `rotate(${index * 15}deg)`,
              }}
            />

          )
        )}

      </div>


     
      {/* =================================================
          DECORATIVE TOP ELEMENTS
      ================================================= */}

      <div className={styles.topDecor}>

        <span className={styles.dove}>
          🕊️
        </span>

        <span className={styles.dove2}>
          🕊️
        </span>

      </div>


      {/* =================================================
          LEFT CHILD
      ================================================= */}

      <div className={styles.leftChild}>

        <img
          src="/assests/img/Indep_day_01.png"
          alt="Child celebrating Independence Day"
        />

      </div>


      {/* =================================================
          RIGHT CHILDREN
      ================================================= */}

      <div className={styles.rightChildren}>

        <img
          src="/assests/img/Indep_day_02.png"
          alt="Children celebrating Independence Day"
        />

      </div>


      {/* =================================================
          MAIN CARD
      ================================================= */}

      <main className={styles.main}>

        <div
          className={`${styles.card} ${
            celebrating
              ? styles.cardCelebrating
              : ""
          }`}
        >


          {/* LOGO */}

          <div className={styles.logoWrapper}>

            <img
              src="/assests/img/baal-logo-footer.png"
              alt="BSCPCR Logo"
              className={styles.logo}
            />

          </div>


          {/* GOVERNMENT TITLE */}

          <div className={styles.hindiTitle}>

            <span>
              बिहार
            </span>

            {" बाल अधिकार संरक्षण "}

            <span>
              आयोग
            </span>

          </div>


          <div className={styles.englishTitle}>

            BIHAR COMMISSION FOR PROTECTION
            OF CHILD RIGHTS

          </div>


          {/* TRICOLOR LINE */}

          <div className={styles.tricolorLine}>

            <span className={styles.saffron}></span>

            <span className={styles.white}></span>

            <span className={styles.green}></span>

          </div>


          {/* OCCASION */}

          <div className={styles.occasion}>

            <div className={styles.occasionSmall}>
              ON THE OCCASION OF
            </div>
            <h1>
              INDEPENDENCE DAY
            </h1>
          </div>


          {/* LAUNCHING */}

          <div className={styles.launching}>

            <div>
              THE OFFICIAL WEBSITE OF BSCPCR
            </div>

            <strong>

              <span>LAUNCHING</span>{" "}

              <span>SOON</span>

            </strong>

          </div>

           <div className={styles.dateRow}>

              <span>
                📅
              </span>

              <strong>
                15 AUGUST 2026
              </strong>

            </div>


          {/* MESSAGE */}

          <div className={styles.message}>

            <strong>
              Protecting Childhood.
              Empowering Rights.
            </strong>

            <br />

            <span>
              Building a Safer and Brighter Future.
            </span>

          </div>


          {/* COUNTDOWN */}

          {/* {!timeLeft.completed && (

            <div className={styles.countdown}>

              <TimeBox
                value={timeLeft.days}
                label="DAYS"
              />

              <TimeBox
                value={timeLeft.hours}
                label="HOURS"
              />

              <TimeBox
                value={timeLeft.minutes}
                label="MINUTES"
              />

              <TimeBox
                value={timeLeft.seconds}
                label="SECONDS"
              />

            </div>

          )} */}


          {/* LIVE */}

          {timeLeft.completed && (

            <div className={styles.live}>

              <span></span>

              WEBSITE IS NOW LIVE

            </div>

          )}


          {/* ENTER BUTTON */}

          <button
            type="button"
            className={styles.enterBtn}
            onClick={handleEnterWebsite}
            disabled={celebrating}
          >

            <span>

              {celebrating
                ? "OPENING WEBSITE..."
                : "ENTER WEBSITE"}

            </span>

            {!celebrating && (
              <b>→</b>
            )}

          </button>


        </div>

      </main>


      {/* =================================================
          BOTTOM TRICOLOR RIBBON
      ================================================= */}

      <div className={styles.bottomRibbon}>

        <div className={styles.ribbonOrange}></div>

        <div className={styles.ribbonWhite}></div>

        <div className={styles.ribbonGreen}></div>

      </div>


      {/* =================================================
          FOOTER
      ================================================= */}

      <footer className={styles.footer}>

        <div>
          स्वतंत्रता दिवस की हार्दिक शुभकामनाएं
        </div>

        <small>
          Bihar Commission for Protection of Child Rights
        </small>

      </footer>


      {/* =================================================
          30 SECOND CELEBRATION
      ================================================= */}

      {celebrating && (

        <div className={styles.celebration}>

          {/* Falling Saffron */}

          {Array.from({ length: 80 }).map(
            (_, index) => (

              <span
                key={`orange-${index}`}
                className={`${styles.falling} ${styles.fallingOrange}`}
                style={{
                  left:
                    `${Math.random() * 100}%`,

                  animationDelay:
                    `${Math.random() * 8}s`,

                  animationDuration:
                    `${5 + Math.random() * 7}s`,
                }}
              >
                ✦
              </span>

            )
          )}


          {/* Falling White */}

          {Array.from({ length: 80 }).map(
            (_, index) => (

              <span
                key={`white-${index}`}
                className={`${styles.falling} ${styles.fallingWhite}`}
                style={{
                  left:
                    `${Math.random() * 100}%`,

                  animationDelay:
                    `${Math.random() * 8}s`,

                  animationDuration:
                    `${5 + Math.random() * 7}s`,
                }}
              >
                ✦
              </span>

            )
          )}


          {/* Falling Green */}

          {Array.from({ length: 80 }).map(
            (_, index) => (

              <span
                key={`green-${index}`}
                className={`${styles.falling} ${styles.fallingGreen}`}
                style={{
                  left:
                    `${Math.random() * 100}%`,

                  animationDelay:
                    `${Math.random() * 8}s`,

                  animationDuration:
                    `${5 + Math.random() * 7}s`,
                }}
              >
                ✦
              </span>

            )
          )}


          {/* CENTER */}

          <div className={styles.celebrationCenter}>

            <div className={styles.bigFlag}>
              🇮🇳
            </div>

            <h2>
              Happy Independence Day
            </h2>

            <p>
              Welcome to <br />
              बिहार बाल अधिकार संरक्षण आयोग
            </p>

            <small>
              Opening Website...
            </small>

          </div>

        </div>

      )}

    </div>

  );

};


export default ComingSoon;